<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <div class="grid" style="grid-template-columns: 1fr 200px">
        <div>
          <ul
            class="items-center gap-x-3 grid"
            style="grid-template-columns: 1fr auto 35%"
          >
            <el-form-item
              label="姓名"
              prop="name"
              :rules="[
                { required: true, message: '请输入名称', trigger: 'blur' },
              ]"
            >
              <el-input v-model="state.model.name"></el-input>
            </el-form-item>
            <el-form-item
              label="性别"
              prop="sex"
              :rules="[
                { required: true, message: '请选择性别', trigger: 'blur' },
              ]"
            >
              <div
                class="rounded px-3 cursor-pointer"
                :class="
                  state.model.sex == '男'
                    ? ' bg-green-800 text-white'
                    : ' text-gray-400 border'
                "
                @click="state.model.sex = '男'"
              >
                男
              </div>
              <div
                class="rounded px-3 ml-2 cursor-pointer"
                :class="
                  state.model.sex == '女'
                    ? ' bg-red-600 text-white'
                    : ' text-gray-400 border'
                "
                @click="state.model.sex = '女'"
              >
                女
              </div>
            </el-form-item>
            <el-form-item
              label="类型"
              prop="d_conferee_type_id"
              :rules="[
                { required: true, message: '请选择类型', trigger: 'blur' },
              ]"
            >
              <el-select v-model="state.model.d_conferee_type_id">
                <el-option
                  v-for="item in state.lx_data"
                  :key="item"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
                <template #footer>
                  <el-button
                    plain
                    class="float-right mb-3"
                    size="small"
                    @click="onLoadLx"
                  >
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
          </ul>
          <ul class="items-center gap-x-3 grid grid-cols-2">
            <el-form-item
              label="手机号"
              prop="phone"
              :rules="[
                { required: true, message: '请选择手机号', trigger: 'blur' },
                { validator: $phone_rules, trigger: 'blur' },
              ]"
            >
              <el-input v-model="state.model.phone"></el-input>
            </el-form-item>
            <el-form-item
              label="证件号"
              prop="idcard"
              :rules="[{ validator: $idcard_rules, trigger: 'blur' }]"
            >
              <el-input v-model="state.model.idcard"></el-input>
            </el-form-item>
          </ul>
        </div>
        <div class="flex flex-col items-center justify-center">
          <el-image
            v-if="state.model.avatar_attachment_id"
            class="w-20 h-20 rounded-full"
            :src="state.model.avatar_attachment_url"
            :preview-src-list="[state.model.avatar_attachment_url]"
            preview-teleported
          />
          <el-image
            v-else
            class="w-20 h-20 rounded-full"
            :src="require('@/assets/images/avatar.png')"
          />
          <el-upload
            :show-file-list="false"
            :auto-upload="false"
            multiple
            :on-change="onAvatarChange"
          >
            <el-button
              dashed
              plan
              icon="plus"
              style="color: var(--el-color-primary)"
              size="large"
              class="!text-xs hover:!text-green-600 hover:!border-green-600 !p-1 mt-2"
            >
              上传头像
            </el-button>
          </el-upload>
        </div>
      </div>
      <el-form-item label="标签">
        <el-select v-model="state.model.d_conferee_tag_json" multiple>
          <el-option
            v-for="item in state.bq_data"
            :key="item"
            :label="item.name"
            :value="item.id"
          ></el-option>
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadBq"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <ul class="items-center gap-x-3 grid grid-cols-2">
        <el-form-item
          label="邮箱"
          prop="email"
          :rules="[{ validator: $email_rules, trigger: 'blur' }]"
        >
          <el-input v-model="state.model.email"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="state.model.address"></el-input>
        </el-form-item>
      </ul>
      <ul class="items-center gap-x-3 grid grid-cols-2">
        <el-form-item label="单位">
          <el-input v-model="state.model.company"></el-input>
        </el-form-item>
        <el-form-item label="职位">
          <el-input v-model="state.model.job"></el-input>
        </el-form-item>
      </ul>
      <el-form-item
        label="负责人"
        prop="belonger_id"
        :rules="[{ required: true, message: '请选择负责人', trigger: 'blur' }]"
      >
        <c_userselect
          v-model="state.model.belonger_id"
          @change:item="
            (item) => {
              state.model.belonger_department_id = item.department_id;
            }
          "
        />
      </el-form-item>
      <el-form-item label="简介">
        <c_editor
          @change="
            (value) => {
              state.model.intro = value;
            }
          "
          :value="state.model.intro"
        ></c_editor>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { dic_getConfereeType, dic_getConfereeTag } from "@/http/data";
import { attachment_upload } from "@/http/attachment";
import { conferee_detail, conferee_add, conferee_edit } from "@/http/conferee";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoadLx();
      onLoadBq();
      onLoadDetail();
    });

    //加载类型
    const onLoadLx = () => {
      dic_getConfereeType().then((res) => {
        if (res.status == 200) state.lx_data = res.data?.data || [];
      });
    };

    //获取标签
    const onLoadBq = () => {
      dic_getConfereeTag().then((res) => {
        if (res.status == 200) state.bq_data = res.data?.data || [];
      });
    };

    //加载详情
    const onLoadDetail = () => {
      if (props.id) {
        conferee_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            if (data.avatar_attachment_id) {
              state.model.avatar_attachment_url =
                data.avatar_attachment?.file_url;
            }
          }
        });
      }
    };

    //头像选择
    const onAvatarChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          const data = res.data.data[0];
          state.model.avatar_attachment_id = data.id;
          state.model.avatar_attachment_url = data.file_url;
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            conferee_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            conferee_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadLx,
      onLoadDetail,
      onSubmit,
      onAvatarChange,
    };
  },
};
</script>
<style scoped></style>
